import { FilterOption } from '@britishcouncil/react-admin';
import { useMemo } from 'react';

import { useGetRegionsQuery } from 'store/regions/regionsApi';

export function useRegionsOptions(): FilterOption<number>[] {
  const { data } = useGetRegionsQuery(undefined);

  const regions = useMemo(
    () =>
      data?.map((region) => ({
        text: region.name,
        value: region.id,
      })) ?? [],
    [data]
  );

  return regions;
}
